module.exports = ":host .title {\n  font-weight: 500;\n  font-size: 0.75rem; }\n\n:host .form-control {\n  font-weight: 300;\n  font-size: 0.75rem;\n  background-color: #1a1a1a;\n  padding: .75rem .92rem;\n  color: #fff;\n  box-shadow: none;\n  -webkit-box-shadow: none; }\n\n:host input[type=text] {\n  border-radius: 1.25rem; }\n\n:host app-date-picker {\n  height: 2.5rem;\n  padding: 0; }\n\n::ng-deep bs-datepicker-container {\n  margin-left: 72px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/competition-details/competition-details.component.scss
// module id = ./src/app/shared/components/competition-details/competition-details.component.scss
// module chunks = main